import React, { useState } from "react";

const HOTELS = [
  { id: "sheraton", name: "MALPENSA Airport Sheraton Hotel", pickup: "11:20", note: "" },
  { id: "cardano_bw", name: "CARDANO Hotel Best Western", pickup: "11:30", note: "东航机组常用酒店" },
  { id: "cardano_novotel", name: "CARDANO Novotel", pickup: "11:45", note: "" },
  { id: "solbiate", name: "SOLBIATE OLONA DoubleTree", pickup: "12:15", note: "" },
  { id: "legnano", name: "LEGNANO Hotel Palace", pickup: "12:30", note: "国航机组常用酒店" },
];

const MONTHS = [
  { year: 2026, month: 4, label: "May 2026" },
  { year: 2026, month: 5, label: "June 2026" },
  { year: 2026, month: 6, label: "July 2026" },
  { year: 2026, month: 7, label: "August 2026" },
  { year: 2026, month: 8, label: "September 2026" },
];

function toKey(date) {
  return `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')}`;
}

function formatDate(date) {
  return date.toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long", year: "numeric" });
}

function formatShort(date) {
  return date.toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short" });
}

function isMWF(date) {
  const d = date.getDay();
  return d === 1 || d === 3 || d === 5;
}

function isDateBlocked(date, todayKey, nowHour, nowMin) {
  const key = toKey(date);
  if (key < todayKey) return true;
  if (key === todayKey) {
    if (nowHour > 12 || (nowHour === 12 && nowMin >= 30)) return true;
  }
  return false;
}

function getDaysInMonth(year, month) {
  return new Date(year, month + 1, 0).getDate();
}

function getFirstDayOfWeek(year, month) {
  let d = new Date(year, month, 1).getDay();
  return d === 0 ? 6 : d - 1;
}

export default function App() {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const todayKey = toKey(today);
  const nowHour = now.getHours();
  const nowMin = now.getMinutes();

  const startMonthIdx = Math.max(0, MONTHS.findIndex(m => {
    const lastDay = new Date(m.year, m.month + 1, 0);
    return lastDay >= today;
  }));

  const [step, setStep] = useState(1);
  const [monthIdx, setMonthIdx] = useState(startMonthIdx);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedHotel, setSelectedHotel] = useState(null);
  const [seats, setSeats] = useState(1);
  const [contactType, setContactType] = useState("email");
  const [form, setForm] = useState({ name: "", contact: "" });
  const [errors, setErrors] = useState({});
  const [confirmed, setConfirmed] = useState(false);
  const [animating, setAnimating] = useState(false);

  const hotel = HOTELS.find(h => h.id === selectedHotel);
  const currentMonth = MONTHS[monthIdx];
  const daysInMonth = getDaysInMonth(currentMonth.year, currentMonth.month);
  const firstDow = getFirstDayOfWeek(currentMonth.year, currentMonth.month);

  function goTo(s) {
    setAnimating(true);
    setTimeout(() => { setStep(s); setAnimating(false); }, 160);
  }

  function validate() {
    const e = {};
    if (!form.name.trim()) e.name = "Full name is required";
    if (!form.contact.trim()) e.contact = "Please provide a contact";
    else if (contactType === "email" && !form.contact.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/))
      e.contact = "Enter a valid email address";
    setErrors(e);
    return Object.keys(e).length === 0;
  }

async function submit() {
    if (!validate()) return;

    setConfirmed(true);
  
    const SCRIPT_URL = "https://script.google.com/macros/s/AKfycbztR7cIU_PUnkUFII48MYO4zdRJU0NF2v-W5HsPpcMp1lRfICwvZyg2nPBtl6PP5s055Q/exec";

    try {
      await fetch(SCRIPT_URL, {
        method: "POST",
        mode: "no-cors",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          date: formatDate(selectedDate),
          hotel: hotel.name,
          pickup: hotel.pickup,
          people: seats,
          name: form.name,
          contactType: contactType,
          contact: form.contact,
        }),
      });
    } catch (err) {
      console.error("Booking error:", err);
    }
  }

  function reset() {
    setConfirmed(false); setStep(1); setSelectedDate(null);
    setSelectedHotel(null); setSeats(1); setForm({ name: "", contact: "" }); setErrors({});
  }

  if (confirmed) {
    return (
      <div style={S.page}>
        <Header />
        <div style={S.confirmBox}>
          <div style={S.checkCircle}>✓</div>
          <h2 style={S.confirmTitle}>Booking confirmed!</h2>
          <p style={S.confirmSub}>You have successfully booked your Chauffeur Transfer to Scalo Milano Outlet & More.</p>
          <div style={S.summaryCard}>
            <Row label="Date" value={formatDate(selectedDate)} />
            <Row label="Hotel" value={hotel.name} />
            <Row label="Pickup time" value={hotel.pickup} />
            <Row label="People" value={seats} />
            <Row label="Name" value={form.name} />
            <Row label={contactType === "whatsapp" ? "WhatsApp" : contactType === "wechat" ? "WeChat" : contactType.charAt(0).toUpperCase()+contactType.slice(1)} value={form.contact} />
          </div>
          <p style={S.noteText}>Please be at your hotel entrance 5 minutes before pickup.<br />Return transfer departs Scalo Milano Outlet & More at 16:30.</p>
          <button style={S.resetBtn} onClick={reset}>Book another trip</button>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div style={S.page}>
      <Header />

      <div style={S.progressBar}>
        {["Date", "Hotel", "Seats", "Details"].map((label, i) => (
          <div key={i} style={S.progressStep}>
            <div style={{
              ...S.progressDot,
              background: step > i+1 ? "#1a1a1a" : step === i+1 ? "#1a1a1a" : "transparent",
              border: step >= i+1 ? "2px solid #1a1a1a" : "2px solid #ccc",
              color: step > i+1 ? "#fff" : step === i+1 ? "#fff" : "#999",
            }}>
              {step > i+1 ? "✓" : i+1}
            </div>
            <span style={{ ...S.progressLabel, color: step >= i+1 ? "#1a1a1a" : "#bbb" }}>{label}</span>
          </div>
        ))}
      </div>

      <div style={{ ...S.card, opacity: animating ? 0 : 1, transition: "opacity 0.16s" }}>

        {/* STEP 1 — CALENDAR */}
        {step === 1 && (
          <>
            <h2 style={S.stepTitle}>Select a date</h2>
            <p style={S.stepSub}>Transfer runs every Monday, Wednesday and Friday</p>

            <div style={S.monthNav}>
              <button style={S.monthNavBtn} disabled={monthIdx === 0} onClick={() => setMonthIdx(i => i-1)}>←</button>
              <span style={S.monthLabel}>{currentMonth.label}</span>
              <button style={S.monthNavBtn} disabled={monthIdx === MONTHS.length-1} onClick={() => setMonthIdx(i => i+1)}>→</button>
            </div>

            <div style={S.calGrid}>
              {["Mon","Tue","Wed","Thu","Fri","Sat","Sun"].map(d => (
                <div key={d} style={S.calHeader}>{d}</div>
              ))}
              {Array.from({ length: firstDow }).map((_,i) => (
                <div key={`e${i}`} style={{ height: 44 }} />
              ))}
              {Array.from({ length: daysInMonth }).map((_,i) => {
                const dayNum = i + 1;
                const date = new Date(currentMonth.year, currentMonth.month, dayNum);
                const mwf = isMWF(date);
                const blocked = isDateBlocked(date, todayKey, nowHour, nowMin);
                const key = toKey(date);
                const isSelected = selectedDate && toKey(selectedDate) === key;
                const isToday = key === todayKey;
                const bookable = mwf && !blocked;

                const cellBg = isSelected ? "#1a1a1a"
                  : bookable ? "#fff"
                  : "transparent";
                const cellBorder = isSelected ? "1.5px solid #1a1a1a"
                  : bookable ? "1px solid #e8e8e8"
                  : "1px solid transparent";
                const numColor = isSelected ? "#fff"
                  : !mwf ? "#d0d0d0"
                  : blocked ? "#bbb"
                  : "#1a1a1a";

                return (
                  <button
                    key={key}
                    disabled={!bookable}
                    onClick={() => bookable && setSelectedDate(date)}
                    style={{
                      height: 46, borderRadius: 6,
                      border: cellBorder,
                      background: cellBg,
                      display: "flex", flexDirection: "column",
                      alignItems: "center", justifyContent: "center",
                      cursor: bookable ? "pointer" : "default",
                      position: "relative", padding: 0, gap: 2,
                    }}
                  >
                    <span style={{ fontSize: 13, fontWeight: mwf && !blocked ? 500 : 400, color: numColor, lineHeight: 1 }}>
                      {dayNum}
                    </span>
                    {isToday && (
                      <span style={{ width: 4, height: 4, borderRadius: "50%", background: isSelected ? "#fff" : "#3b82f6", display: "block" }} />
                    )}
                    {bookable && !isSelected && !isToday && (
                      <span style={{ width: 3, height: 3, borderRadius: "50%", background: "#c9a84c", display: "block" }} />
                    )}
                  </button>
                );
              })}
            </div>

            <div style={S.legend}>
              <span style={S.legendItem}><span style={{ ...S.legendDot, background: "#1a1a1a" }} />Selected</span>
              <span style={S.legendItem}><span style={{ ...S.legendDot, background: "#c9a84c" }} />Available (Mon/Wed/Fri)</span>
              <span style={S.legendItem}><span style={{ ...S.legendDot, background: "#e0e0e0" }} />Unavailable</span>
              <span style={S.legendItem}><span style={{ ...S.legendDot, background: "#3b82f6" }} />Today</span>
            </div>

            {selectedDate && (
              <div style={S.selectedBanner}>
                <span style={{ fontSize: 12, color: "#888" }}>Selected:</span>
                <span style={{ fontSize: 14, fontWeight: 600, color: "#1a1a1a" }}>{formatDate(selectedDate)}</span>
              </div>
            )}

            <button
              disabled={!selectedDate}
              style={{ ...S.nextBtn, ...(selectedDate ? {} : S.nextBtnDisabled) }}
              onClick={() => goTo(2)}
            >Continue →</button>
          </>
        )}

        {/* STEP 2 — HOTEL */}
        {step === 2 && (
          <>
            <h2 style={S.stepTitle}>Your hotel</h2>
            <p style={S.stepSub}>We'll pick you up at your hotel entrance</p>
            <div style={S.hotelList}>
              {HOTELS.map(h => {
                const active = selectedHotel === h.id;
                return (
                  <button
                    key={h.id}
                    onClick={() => setSelectedHotel(h.id)}
                    style={{ ...S.hotelBtn, ...(active ? S.hotelBtnActive : {}) }}
                  >
                    <div style={{ flex: 1, textAlign: "left" }}>
                      <div style={{ fontSize: 14, fontWeight: 500, color: active ? "#fff" : "#1a1a1a" }}>{h.name}</div>
                      {h.note ? <div style={{ fontSize: 12, color: active ? "#f0d080" : "#aaa", marginTop: 2 }}>{h.note}</div> : null}
                    </div>
                    <div style={{ fontSize: 13, fontWeight: 600, color: active ? "#f0d080" : "#c9a84c", flexShrink: 0, marginLeft: 12 }}>
                      {h.pickup}
                    </div>
                  </button>
                );
              })}
            </div>
            <div style={S.navRow}>
              <button style={S.backBtn} onClick={() => goTo(1)}>← Back</button>
              <button
                disabled={!selectedHotel}
                style={{ ...S.nextBtn, ...(selectedHotel ? {} : S.nextBtnDisabled) }}
                onClick={() => goTo(3)}
              >Continue →</button>
            </div>
          </>
        )}

        {/* STEP 3 — SEATS */}
        {step === 3 && (
          <>
            <h2 style={S.stepTitle}>Number of people</h2>
            <p style={S.stepSub}>How many seats do you need?</p>
            <div style={S.seatRow}>
              <button style={S.seatBtn} onClick={() => setSeats(s => Math.max(1, s - 1))}>−</button>
              <div style={S.seatCount}>{seats}</div>
              <button style={S.seatBtn} onClick={() => setSeats(s => Math.min(16, s + 1))}>+</button>
            </div>
            <div style={{ background: "#f7f5f0", borderRadius: 8, padding: "10px 16px", marginBottom: 22 }}>
              <Row label="Date" value={formatShort(selectedDate)} />
              <Row label="Hotel" value={hotel?.name} />
              <Row label="Pickup" value={hotel?.pickup} />
            </div>
            <div style={S.navRow}>
              <button style={S.backBtn} onClick={() => goTo(2)}>← Back</button>
              <button style={S.nextBtn} onClick={() => goTo(4)}>Continue →</button>
            </div>
          </>
        )}

        {/* STEP 4 — DETAILS */}
        {step === 4 && (
          <>
            <h2 style={S.stepTitle}>Your details</h2>
            <p style={S.stepSub}>Full name required, plus at least one contact</p>

            <div style={S.formGroup}>
              <label style={S.formLabel}>Full name *</label>
              <input
                style={{ ...S.formInput, ...(errors.name ? S.inputError : {}) }}
                placeholder="Maria Rossi"
                value={form.name}
                onChange={e => setForm(f => ({ ...f, name: e.target.value }))}
              />
              {errors.name && <span style={S.errMsg}>{errors.name}</span>}
            </div>

            <div style={S.formGroup}>
              <label style={S.formLabel}>Contact *</label>
              <div style={S.contactTabs}>
                {[
                  { key: "email", label: "Email" },
                  { key: "whatsapp", label: "WhatsApp" },
                  { key: "phone", label: "Phone" },
                  { key: "wechat", label: "WeChat" },
                ].map(t => (
                  <button
                    key={t.key}
                    style={{ ...S.contactTab, ...(contactType === t.key ? S.contactTabActive : {}) }}
                    onClick={() => { setContactType(t.key); setForm(f => ({ ...f, contact: "" })); setErrors(e => ({ ...e, contact: undefined })); }}
                  >{t.label}</button>
                ))}
              </div>
              <input
                style={{ ...S.formInput, ...(errors.contact ? S.inputError : {}) }}
                placeholder={
                  contactType === "email" ? "maria@example.com"
                  : contactType === "whatsapp" ? "+39 333 000 0000"
                  : contactType === "phone" ? "+39 333 000 0000"
                  : "WeChat ID"
                }
                type={contactType === "email" ? "email" : contactType === "phone" ? "tel" : "text"}
                value={form.contact}
                onChange={e => setForm(f => ({ ...f, contact: e.target.value }))}
              />
              {errors.contact && <span style={S.errMsg}>{errors.contact}</span>}
            </div>

            <div style={S.finalSummary}>
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap", fontSize: 14, fontWeight: 500, marginBottom: 4, color: "#fff" }}>
                <span>{formatShort(selectedDate)}</span>
                <span style={{ color: "#666" }}>·</span>
                <span>{hotel?.name}</span>
                <span style={{ color: "#666" }}>·</span>
                <span>{seats} {seats === 1 ? "person" : "people"}</span>
              </div>
              <div style={{ fontSize: 12, color: "#c9a84c", fontWeight: 500 }}>Pickup at {hotel?.pickup}</div>
            </div>

            <div style={S.navRow}>
              <button style={S.backBtn} onClick={() => goTo(3)}>← Back</button>
              <button style={S.nextBtn} onClick={submit}>Confirm booking →</button>
            </div>
          </>
        )}
      </div>
      <Footer />
    </div>
  );
}

function Header() {
  return (
    <>
      <div style={{ width: "100%", height: "clamp(160px, 25vw, 500px)", overflow: "hidden", position: "relative", }}>
        <img 
          src="/hero.jpg" 
          alt="Scalo Milano" 
          style={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: "top center", display: "block", }} 
        />
      </div>
      <header style={S.header}>
        <div style={S.logoRow}>
          <img src="/logo.png" alt="Scalo Milano" style={{ height: 50, width: "auto" }} />
          <div>
            <div style={S.logoTitle}>Free Premium Chauffeur Transfer Service to Scalo Milano Outlet & More</div>
            <div style={S.logoSub}>米兰 Scalo Milano 奥特莱斯免费班车预约</div>
          </div>
        </div>
        <div style={S.headerMeta}>Glory Travel | +39 349 837 8516</div>
      </header>
    </>
  );
}

function Footer() {
  return (
    <footer style={S.footer}>
      Scalo Milano Outlet & More · Via Milano 5, Locate Triulzi · Return shuttle 16:30
    </footer>
  );
}

function Row({ label, value }) {
  return (
    <div style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: "0.5px solid #eee", fontSize: 14 }}>
      <span style={{ color: "#888" }}>{label}</span>
      <span style={{ fontWeight: 500, textAlign: "right", maxWidth: "65%" }}>{value}</span>
    </div>
  );
}

const S = {
  page: {
    fontFamily: "'DM Sans','Helvetica Neue',sans-serif",
    background: "#f7f5f0", minHeight: "100vh",
    display: "flex", flexDirection: "column", alignItems: "center", padding: "0 0 48px",
  },
  header: {
    width: "100%", background: "#1a1a1a", color: "#fff",
    padding: "20px 28px", display: "flex", alignItems: "center",
    justifyContent: "space-between", flexWrap: "wrap", gap: 12, boxSizing: "border-box",
  },
  logoRow: { display: "flex", alignItems: "center", gap: 14 },
  logoMark: {
    width: 42, height: 42, borderRadius: 4, background: "#c9a84c",
    display: "flex", alignItems: "center", justifyContent: "center",
    fontWeight: 700, fontSize: 16, color: "#1a1a1a", letterSpacing: 1, flexShrink: 0,
  },
  logoTitle: { fontSize: 14, fontWeight: 600, letterSpacing: 0.3, lineHeight: 1.3 },
  logoSub: { fontSize: 11, color: "#999", marginTop: 3 },
  headerMeta: { fontSize: 12, color: "#888", letterSpacing: 0.3 },
  progressBar: {
    display: "flex", width: "100%", maxWidth: 520,
    margin: "28px auto 0", padding: "0 20px", boxSizing: "border-box",
    justifyContent: "space-between", alignItems: "center",
  },
  progressStep: { display: "flex", flexDirection: "column", alignItems: "center", gap: 5, flex: 1 },
  progressDot: {
    width: 28, height: 28, borderRadius: "50%",
    display: "flex", alignItems: "center", justifyContent: "center",
    fontSize: 12, fontWeight: 600, transition: "all 0.2s",
  },
  progressLabel: { fontSize: 11, fontWeight: 500, letterSpacing: 0.3 },
  card: {
    background: "#fff", borderRadius: 12, padding: "24px 20px 22px",
    margin: "20px auto 0", width: "100%", maxWidth: 520,
    boxSizing: "border-box", boxShadow: "0 1px 3px rgba(0,0,0,0.07)",
  },
  stepTitle: { fontSize: 20, fontWeight: 600, margin: "0 0 4px", color: "#1a1a1a" },
  stepSub: { fontSize: 13, color: "#888", margin: "0 0 16px" },
  monthNav: { display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 },
  monthNavBtn: {
    width: 32, height: 32, borderRadius: 6, border: "1.5px solid #e0e0e0",
    background: "#fff", fontSize: 16, cursor: "pointer", color: "#555",
    display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "inherit",
  },
  monthLabel: { fontSize: 15, fontWeight: 600, color: "#1a1a1a" },
  calGrid: { display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 3, marginBottom: 12 },
  calHeader: { fontSize: 11, fontWeight: 600, color: "#aaa", textAlign: "center", padding: "4px 0", letterSpacing: 0.3 },
  legend: { display: "flex", gap: 14, marginBottom: 12, flexWrap: "wrap" },
  legendItem: { display: "flex", alignItems: "center", gap: 5, fontSize: 11, color: "#999" },
  legendDot: { width: 8, height: 8, borderRadius: "50%", display: "inline-block" },
  selectedBanner: {
    display: "flex", alignItems: "center", gap: 10,
    background: "#f7f5f0", borderRadius: 8, padding: "10px 14px", marginBottom: 14,
  },
  seatRow: { display: "flex", alignItems: "center", justifyContent: "center", gap: 32, margin: "16px 0 28px" },
  seatBtn: {
    width: 48, height: 48, borderRadius: 24, border: "1.5px solid #ddd",
    background: "#fff", fontSize: 24, fontWeight: 300, cursor: "pointer",
    display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "inherit",
  },
  seatCount: { fontSize: 52, fontWeight: 700, color: "#1a1a1a", minWidth: 64, textAlign: "center" },
  hotelList: { display: "flex", flexDirection: "column", gap: 8, marginBottom: 22 },
  hotelBtn: {
    display: "flex", justifyContent: "space-between", alignItems: "center",
    padding: "14px 16px", borderRadius: 8, border: "1.5px solid #e8e8e8",
    background: "#fff", cursor: "pointer", transition: "all 0.15s", fontFamily: "inherit",
  },
  hotelBtnActive: { border: "1.5px solid #1a1a1a", background: "#1a1a1a" },
  formGroup: { display: "flex", flexDirection: "column", gap: 6, marginBottom: 18 },
  formLabel: { fontSize: 13, fontWeight: 500, color: "#555" },
  formInput: {
    padding: "11px 14px", borderRadius: 8, border: "1.5px solid #e0e0e0",
    fontSize: 15, outline: "none", background: "#fff", transition: "border 0.15s",
    boxSizing: "border-box", width: "100%", fontFamily: "inherit",
  },
  inputError: { border: "1.5px solid #e74c3c" },
  errMsg: { fontSize: 12, color: "#e74c3c" },
  contactTabs: { display: "flex", gap: 6, marginBottom: 8, flexWrap: "wrap" },
  contactTab: {
    padding: "6px 14px", borderRadius: 20, border: "1.5px solid #e0e0e0",
    background: "#fff", fontSize: 13, cursor: "pointer", color: "#555", fontFamily: "inherit",
  },
  contactTabActive: { background: "#1a1a1a", color: "#fff", border: "1.5px solid #1a1a1a" },
  finalSummary: { background: "#1a1a1a", borderRadius: 8, padding: "14px 16px", margin: "4px 0 22px" },
  navRow: { display: "flex", gap: 10, justifyContent: "flex-end" },
  nextBtn: {
    padding: "12px 24px", borderRadius: 8, border: "none",
    background: "#1a1a1a", color: "#fff", fontWeight: 600,
    fontSize: 15, cursor: "pointer", fontFamily: "inherit",
  },
  nextBtnDisabled: { background: "#ccc", cursor: "not-allowed" },
  backBtn: {
    padding: "12px 18px", borderRadius: 8, border: "1.5px solid #ddd",
    background: "transparent", color: "#666", fontWeight: 500,
    fontSize: 15, cursor: "pointer", fontFamily: "inherit",
  },
  confirmBox: {
    background: "#fff", borderRadius: 12, padding: "36px 28px",
    margin: "40px auto", maxWidth: 480, width: "100%",
    boxSizing: "border-box", textAlign: "center", boxShadow: "0 1px 3px rgba(0,0,0,0.07)",
  },
  checkCircle: {
    width: 56, height: 56, borderRadius: "50%", background: "#d4f0e0", color: "#1a6b3c",
    display: "flex", alignItems: "center", justifyContent: "center",
    fontSize: 24, fontWeight: 700, margin: "0 auto 18px",
  },
  confirmTitle: { fontSize: 24, fontWeight: 700, margin: "0 0 8px", color: "#1a1a1a" },
  confirmSub: { fontSize: 15, color: "#666", margin: "0 0 22px", lineHeight: 1.5 },
  summaryCard: { background: "#f7f5f0", borderRadius: 8, padding: "4px 16px", marginBottom: 18, textAlign: "left" },
  noteText: { fontSize: 13, color: "#999", lineHeight: 1.7, margin: "0 0 24px" },
  resetBtn: {
    padding: "12px 24px", borderRadius: 8, border: "1.5px solid #ddd",
    background: "transparent", color: "#555", fontWeight: 500,
    fontSize: 14, cursor: "pointer", fontFamily: "inherit",
  },
  footer: { fontSize: 12, color: "#aaa", textAlign: "center", marginTop: 28, padding: "0 20px" },
};
